document.addEventListener('DOMContentLoaded', function () {
  const beltSelect = document.getElementById('BeltColour');
  const beltError = document.getElementById('BeltColourError');

  if (!beltSelect) return;

  // Clear error styling when user makes a valid selection
  beltSelect.addEventListener('change', function () {
    if (this.value !== '') {
      if (beltError) beltError.style.display = 'none';
      beltSelect.style.borderColor = '#000';
    }
  });

  // Find submit button — try multiple selectors to cover theme variations
  const submitBtn = document.querySelector(
    '[type="submit"].product-form__submit, button[type="submit"][name="add"], button[type="submit"].btn-addtocart'
  ) || document.querySelector('form[action="/cart/add"] [type="submit"]');

  if (!submitBtn) return;

  submitBtn.addEventListener('click', function (e) {
    const selected = beltSelect.options[beltSelect.selectedIndex];
    const beltVariantId = selected ? selected.dataset.variantId : '';

    if (!beltVariantId) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (beltError) beltError.style.display = 'block';
      beltSelect.style.borderColor = 'red';
      beltSelect.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);
});